import { DataService } from "@/services/data";
import { RouteObject, defer, redirect } from "react-router-dom";
import { PaginatedResponse } from "@/types/common";
import { CatalogType } from "@/types/content/catalog";
import { LightProductType } from "@/types/content/product";
import { ProductThemeType } from "@/types/content/product_theme";

const GeneralisteRoute: RouteObject = {
    path: "generaliste",
    children: [
        {
            index: true,
            async lazy() {
                let { GeneralistePage } = await import("@/pages/content/generaliste/index");
                return { Component: GeneralistePage };
            },
            loader: async ({ request }) => {
                const url = new URL(request.url);
                const catalogs = (await DataService.client.url(`/content/catalogs?sante=0&is_displayed=1&page_size=250`).get().json()) as PaginatedResponse<CatalogType>;
                let product_themes = undefined;
                url.searchParams.set("page_size", url.searchParams.get("page_size") || "8");
                url.searchParams.set("domain", "learning");
                url.searchParams.set("is_active", "1");

                product_themes = (await DataService.client
                    .url(`/content/product_themes/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                    .get()
                    .json()) as PaginatedResponse<ProductThemeType>;

                const ignoredCatalogs = ["alternance", "edumiam", "sante"];
                return defer({
                    catalogs: catalogs.results.filter(c => !ignoredCatalogs.includes(c.sf_value)),
                    product_themes: product_themes
                });
            }
        },
        {
            id: "generaliste-detail",
            path: ":id",
            async lazy() {
                let { GeneralisteDetailPage } = await import("@/pages/content/generaliste/detail");
                return { Component: GeneralisteDetailPage };
            },
            loader: async ({ params }) => {
                const id = params.id;
                const product_theme = (await DataService.client.url(`/content/product_themes/${id}/?domain=learning`).get().json()) as ProductThemeType;
                return { product_theme };
            }
        },
        {
            // Redirect route: resolves a product_code to its theme and redirects to the
            // proper detail page. Used by the funder table when theme_id is unknown.
            path: "by-product/:product_code",
            loader: async ({ params, request }) => {
                const { product_code } = params;
                const url = new URL(request.url);
                const qs = new URLSearchParams();
                for (const [key, value] of url.searchParams.entries()) qs.set(key, value);
                qs.set("product", product_code!);

                try {
                    const data = (await DataService.client
                        .url(`/content/products/?code=${product_code}&page_size=1`)
                        .get()
                        .json()) as PaginatedResponse<LightProductType>;
                    const product = data.results[0];
                    const rawTheme = product?.product_themes?.[0] as unknown;
                    const themeId = typeof rawTheme === "number"
                        ? rawTheme
                        : (rawTheme as { id?: number } | undefined)?.id;
                    if (themeId) {
                        return redirect(`/catalogue/generaliste/${themeId}?${qs.toString()}`);
                    }
                } catch {
                    // fall through to listing
                }
                return redirect(`/catalogue/generaliste`);
            },
            element: null,
        }
    ]
};
export default GeneralisteRoute;
